import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core'

class TableView extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    valueFormatter: PropTypes.func,
  }

  static defaultProps = {
    valueFormatter: (v) => (v.toString()),
  }

  format = (k, v) => {
    switch (k) {
      case 'timestamp':
        return moment(v).local().format('LLL')
      default:
        return this.props.valueFormatter(v)
    }
  }

  render() {
    const { data } = this.props
    if (data.length === 0) {
      return null
    }
    const headers = Object.keys(data[0])
    return (
      <Table>
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableCell key={header}>{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <TableRow key={index}>
              {Object.entries(item).map(([k, val]) => (
                <TableCell key={k}>{this.format(k, val)}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }
}

export default TableView
